import React from 'react';

import { Button } from '@asphalt-react/button';

interface GPMotionControlsProps {
  methodName: string;
  onStart: () => void;
  onStop: () => void;
}

const GPMotionControls: React.FC<GPMotionControlsProps> = ({
  onStart,
  onStop,
}) => (
  <div className="mb-4 flex flex-col gap-2 sm:flex-row">
    <Button onClick={onStart} size="m" stretch secondary>
      Start
    </Button>
    <Button onClick={onStop} size="m" stretch secondary>
      Stop
    </Button>
  </div>
);

export default GPMotionControls;
